import { defineStore } from 'pinia'

export const useSearchStore = defineStore('search', {
    state: () => ({
        keyword: '',
    }),
    actions: {
        updateKeyword(keyword) {
            // Normalize input - accept either format (spaces or underscores)
            this.keyword = (keyword || '').replace(/_/g, ' ').trim()
        },
    },
})
